import styled from "styled-components";
import { Quill } from "react-quill";
const Font = Quill.import("formats/font");
Font.whitelist = [
  "Roboto", "Raleway", "Montserrat", "Lato", "Rubik",
  "Open-Sans", "Poppins", "Nunito",  // Sans-Serif
  "Playfair-Display", "Merriweather", "Georgia",  // Serif
  "Courier-New", "Roboto-Mono", "Fira-Code", "Source-Code-Pro" // Monospace
];

// Register the modified font list
Quill.register(Font, true);

const Size = Quill.import('formats/size');
Size.whitelist = ['10', '12', '14', '16', '18', '20', '24', '28', '32', '36'];
Quill.register(Size, true);

export const PageWrapper = styled.div`
  height: 100vh;
  background-color: #adacc0;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 2rem;
  overflow-y: auto;
  @media (max-width: 768px) {
    padding: 1rem; 
  }
`;

export const LogoContainer = styled.div`
  width: 100%;
  display: flex;
  justify-content: flex-start;
  @media (max-width: 768px) {
    padding: 1rem; 
  }
`;

export const Logo = styled.img`
  width: 150px;
  height: auto;
`;
export const ContentContainer = styled.div`
  background: white;
  padding: 2rem;
  max-width: calc(85vw);
  width: 100%;
  border-radius: 10px;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1);
  margin-top: 20px;
  line-height: 1.6;  
  text-align: justify; 
  word-wrap: break-word; 
  font-family: inherit !important;

  @media (max-width: 768px) {
    max-width: 100%;
    padding: 1.5rem;
  }

  h1 {
    font-size: 2rem;
  }

  h2 {
    font-size: 1.75rem;
  }

  h3 {
    font-size: 1.5rem;
  }

  h4 {
    font-size: 1.25rem;
  }

  h5 {
    font-size: 1.1rem;
  }

  h6 {
    font-size: 1rem;
  }

  
  /* Style paragraphs inside */
  /* p {
    margin-bottom: 1rem;
  } */
  
  /* Style headings inside */
  /* h1, h2, h3, h4, h5, h6 {
    margin-top: 1.5rem;
    margin-bottom: 0.75rem;
  } */
  
  /* Ensure lists have proper spacing */
  /* ul, ol {
    margin-bottom: 1rem;
    padding-left: 1.5rem;
  } */

 .ql-editor {
    counter-reset: list-counter; /* Reset for custom numbering */
  }

  .ql-editor ol {
    list-style-type: decimal;
  }

  .ql-editor ol li {
    counter-increment: list-counter;
  }

  .ql-editor ol li::before {
    content: counter(list-counter) ". ";
  }
  ${Font.whitelist.map((font) => {
    const className = font.replace(/\s/g, "-"); // Replace spaces with hyphens
    return `
      .ql-picker.ql-font .ql-picker-label[data-value="${font}"]::before, 
      .ql-picker.ql-font .ql-picker-item[data-value="${font}"]::before {
        font-family: "${font.replace(/-/g, " ")}";  
        content: "${font.replace(/-/g, " ")}";
      }
      .ql-font-${className} {
        font-family: "${font.replace(/-/g, " ")}";
      }
    `;
  }).join("\n")}

${Size.whitelist
    .map((size) => `
      .ql-snow .ql-picker.ql-size .ql-picker-label[data-value='${size}']::before,
      .ql-snow .ql-picker.ql-size .ql-picker-item[data-value='${size}']::before {
        content: '${size}';
      }
      .ql-size-${size} {
       font-size: ${size}px;
      }
    `)
    .join('\n')}
`;
